"use strict";

const { CrossAppEvent, onCrossAppEvent } = require("./cross-app/events");

const ClinicalBadgesPort = {
  add: function (app) {
    if (!app.ports.onClinicalBadgeCounts) return;

    onCrossAppEvent(CrossAppEvent.CLINICAL_BADGE_COUNTS, (detail) => {
      app.ports.onClinicalBadgeCounts.send(detail);
    });
  },
};

module.exports = ClinicalBadgesPort;
